import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared.module';
import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { AppPreloader } from 'src/app/app-routing-loader';
import { PostLoginAuthGuard } from 'src/app/components/layout/guard/post-login-auth.guard';

// layouts & notfound
import { LayoutAuthComponent } from 'src/app/layouts/Auth/auth.component';
import { LayoutAppComponent } from 'src/app/layouts/App/app.component';
import { NotFoundComponent } from 'src/app/pages/404.component';
import { LayoutSettingComponent } from './layouts/Setting/setting.component';

const COMPONENTS = [NotFoundComponent];

const routes: Routes = [
  {
    path: '',
    redirectTo: 'wallets',
    canActivate: [PostLoginAuthGuard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'auth',
    component: LayoutAuthComponent,
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/auth/auth.module#AuthModule',
      },
    ],
  },
  // {
  //   path: 'dashboard',
  //   component: LayoutAppComponent,
  //   canActivate: [PostLoginAuthGuard],
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: 'src/app/pages/dashboard/dashboard.module#DashboardModule',
  //     },
  //   ],
  // },
  {
    path: 'deposit-requests',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/deposit-request/deposit-request.module#DepositRequestModule',
      },
    ],
  },
  {
    path: 'withdraw-requests',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren:
          'src/app/pages/withdraw-request/withdraw-request.module#WithdrawRequestModule',
      },
    ],
  },
  {
    path: 'user',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/user/user.module#UserModule',
      },
    ],
  },
  {
    path: 'settings',
    component: LayoutSettingComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/settings/settings.module#SettingsModule',
      },
    ],
  },
  {
    path: 'wallets',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/wallet-summary/wallet-summary.module#WalletSummaryModule',
      },
    ],
  },
  {
    path: 'events',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/events/events.module#EventsModule',
      },
    ],
  },
  {
    path: 'admin-wallet',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/wallet-admin/wallet-admin.module#WalletAdminModule',
      },
    ],
  },
  {
    path: 'agencies',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/agency-summary/agency-summary.module#AgencySummaryModule',
      },
    ],
  },
  {
    path: 'fix-transaction',
    component: LayoutAppComponent,
    canActivate: [PostLoginAuthGuard],
    children: [
      {
        path: '',
        loadChildren: 'src/app/pages/fix-transaction/fix-transaction.module#FixTransactionModule',
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: { title: '404 - Page not found' },
  },
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      // useHash: true,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: AppPreloader,
    }),
    LayoutsModule,
  ],
  providers: [AppPreloader],
  declarations: [...COMPONENTS],
  exports: [RouterModule],
})
export class AppRoutingModule { }
